// Extension → MIME type(s) mapping. Single source of truth for the file types a Siesta chat
// can accept as an attachment (these mirror what the chat-file backend can parse).
const CHAT_FILE_TYPES: Record<string, string[]> = {
  '.pdf': ['application/pdf'],
  '.png': ['image/png'],
  '.jpg': ['image/jpeg'],
  '.jpeg': ['image/jpeg'],
  '.tiff': ['image/tiff'],
  '.bmp': ['image/bmp'],
  '.webp': ['image/webp'],
  '.docx': ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  '.txt': ['text/plain'],
  '.rtf': ['application/rtf', 'text/rtf'],
  '.xlsx': ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  '.csv': ['text/csv'],
};

const CHAT_FILE_EXTENSIONS = Object.keys(CHAT_FILE_TYPES);

// Comma-separated extensions for the HTML file picker (Mantine FileButton's accept prop).
export const CHAT_FILE_BUTTON_ACCEPT = CHAT_FILE_EXTENSIONS.join(',');

// Inverted mapping: MIME type → extensions, for Mantine Dropzone's accept prop.
export const CHAT_FILE_DROPZONE_ACCEPT = Object.entries(CHAT_FILE_TYPES).reduce<
  Record<string, string[]>
>((acc, [ext, mimeTypes]) => {
  for (const mime of mimeTypes) {
    if (!acc[mime]) acc[mime] = [];
    acc[mime].push(ext);
  }
  return acc;
}, {});

export const CHAT_FILE_FORMATS_LABEL = CHAT_FILE_EXTENSIONS.map(ext =>
  ext.slice(1).toUpperCase(),
).join(', ');
